package one.healthium.log_food.ui.mappers

import one.healthium.log_food.domain.FoodModel
import one.healthium.profile.ui.food.models.FoodUiModel

class FoodUiMapper {
    fun toUiModel(model: FoodModel): FoodUiModel {
        return FoodUiModel(
            emoji = model.emoji,
            product = model.product,
            description = model.description,
            calories = model.calories,
            fat = model.fat,
            carbohydrates = model.carbohydrates,
            fiber = model.fiber,
            protein = model.protein,
            tablespoon = model.tablespoon,
            cups = model.cups,
            pieces = model.pieces,
            pieceCount = model.pieceCount,
            portion = null,
            isLiquid = model.isLiquid,
            portionSize = model.portionSize,
        )
    }
}
